import React from 'react';
import { NavLink } from 'react-router-dom';

export const NotFoundScreen = () => {
  return (
    <div>
      <h3>404 - page not found</h3>
      <NavLink to="/">home</NavLink>
    </div>
  );
};
